export default __webpack_public_path__ + "static/media/flag-USA-160.dc52c3c6.png";